import React from 'react'
import styled from 'styled-components'
import { graphql, compose } from 'react-apollo'
import CancelEsign from './../queries/CancelEsign'
import FadeInUpWrapper from '../../common/FadeInUpWrapper'


const Body = styled(FadeInUpWrapper)`
  width: 45%;
  background: white;
  border-radius: 3px;
  border: 1px solid gray;
  padding: 20px;
  box-shadow: 0 4px 10px -2px rgba(0,0,0,0.3);
  display: flex;
  justify-content: center;
  flex-direction: column;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px 0 30px 0;
  }
  span {
    width: 100%;
    text-align: center;
    margin: 0 0 20px 0;
  }
`
const Title = styled.span`
  font-size: 18px;
  width: 100%;
  text-align: center;
  padding: 30px 0 0 0;
`
const Button = styled.button`
  font-size: 14px;
  line-height: 14px;
  height: 30px;
  margin: 0 10px;
  font-weight: 200;
  padding: 7px 10px;
  border-radius: 4px;
  border: none;
  color: white;
  background-color: ${props => props.bgColor};
`

class CancelEsignModal extends React.Component {
  cancelEsignRequest = async () => {
    try {
      await this.props.cancelEsign({
        variables: {
          documentId: this.props.document.rid
        }
      })
      this.props.toggleModal()
    } catch (err) {
      console.log(err)
    }
  }
  render() {
    const { toggleModal } = this.props
    return (
      <Body id="cancel_esign_modal">
        <Title>Cancel E-Sign Request</Title>
        <span>Are you sure you want to cancel the signature request?</span>
        <div>
          <Button bgColor={'#9B9B9B'} onClick={toggleModal} id="do_not_cancel_esign">
            No, do not cancel
          </Button>
          <Button bgColor={'#DC6A00'} onClick={this.cancelEsignRequest} id="cancel_esign">
            Yes, cancel
          </Button>
        </div>
      </Body>
    )
  }
}

const CancelEsignModalWithQuery = compose(
  graphql(CancelEsign, {
    name: 'cancelEsign'
  }),
)(CancelEsignModal)

export default CancelEsignModalWithQuery